/**
 * [is Visible Check if an element is visible or not (Elements are considered visible if they consume space in the document. )]
 * @return {boolean} [Visible elements have a width or height that is greater than zero]
 */
export function isVisible(element) {
    return element.offsetWidth > 0 && element.offsetHeight > 0;
}